import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lock, Zap } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";

export const LockedGate = ({ title, blurb, testid = "locked-gate" }) => {
  const navigate = useNavigate();
  return (
    <DashboardShell>
      <div className="p-6 md:p-10 max-w-2xl mx-auto">
        <div className="rounded-2xl border border-primary/30 bg-gradient-to-b from-primary/10 to-transparent p-12 text-center" data-testid={testid}>
          <div className="w-16 h-16 rounded-2xl bg-primary/15 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <h1 className="font-heading text-3xl font-black tracking-tight">{title}</h1>
          <p className="text-muted-foreground mt-3 max-w-md mx-auto">{blurb}</p>
          <Button onClick={() => navigate("/plans")} className="mt-7 rounded-full h-12 px-8 bg-primary text-background font-bold" data-testid={`${testid}-upgrade-btn`}>
            Choose a plan <Zap className="w-4 h-4 ml-1" fill="currentColor" />
          </Button>
        </div>
      </div>
    </DashboardShell>
  );
};

export default LockedGate;
